import { createSvg } from '@r1-frontend/ui-react/components/svg/createSvg';

const Logout = (
    {
        strokeWidth = 1.5,
    },
): JSX.Element => {
    return (
        <g id={'guts'}>
            <path
                d='M8.8999 7.56001C9.2099 3.96001 11.0599 2.49001 15.1099 2.49001H15.2399C19.7099 2.49001 21.4999
                 4.28001 21.4999 8.75001V15.27C21.4999 19.74 19.7099 21.53 15.2399 21.53H15.1099C11.0899 21.53 9.2399
                  20.08 8.9099 16.54'
                strokeWidth={strokeWidth}
                strokeLinecap='round'
                strokeLinejoin='round'
                stroke='currentColor'
            />
            <path
                d='M15.0001 12H3.62012'
                strokeWidth={strokeWidth}
                strokeLinecap='round'
                strokeLinejoin='round'
                stroke='currentColor'
            />
            <path
                d='M5.85 8.65001L2.5 12L5.85 15.35'
                strokeWidth={strokeWidth}
                strokeLinecap='round'
                strokeLinejoin='round'
                stroke='currentColor'
            />
        </g>
    );
};

export default createSvg(
    Logout,
    'logout',
);
